"use client";
import { useCallback, useState } from "react";
import Image from "next/image";
import clsx from "clsx";

import { ChatKitPanel } from "./components/ChatKitPanel";
import { ResearchStatus } from "./components/ResearchStatus";
import { ThemeToggle } from "./components/ThemeToggle";
import { useColorScheme } from "./hooks/useColorScheme";

export default function Page() {
  const { scheme, setScheme } = useColorScheme();
  const [threadId, setThreadId] = useState<string | null>(null);
  const containerClass = clsx(
    "min-h-screen bg-gradient-to-br transition-colors duration-300",
    scheme === "dark"
      ? "from-zinc-950 via-zinc-950 to-zinc-900 text-zinc-100"
      : "from-zinc-100 via-white to-zinc-200 text-zinc-900"
  );

  const handleThreadChange = useCallback((nextThreadId: string | null) => {
    setThreadId(nextThreadId);
  }, []);

  const handleResponseCompleted = useCallback(() => {
    // Handle response completion if needed
  }, []);

  return (
    <div className={containerClass}>
      <div className="mx-auto flex min-h-screen w-full max-w-6xl flex-col gap-8 px-6 py-8 lg:h-screen lg:max-h-screen lg:py-10">
        <header className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="space-y-3">
            <div className="relative h-8 w-auto">
              <Image
                src="/mars_logo_blanc.png"
                alt="Mars Logo"
                fill
                className={clsx(
                  "object-contain object-left transition-opacity duration-500 ease-in-out",
                  scheme === "dark" ? "opacity-100" : "opacity-0 absolute"
                )}
                priority
              />
              <Image
                src="/mars_logo_bleu.png"
                alt="Mars Logo"
                fill
                className={clsx(
                  "object-contain object-left transition-opacity duration-500 ease-in-out",
                  scheme === "dark" ? "opacity-0 absolute" : "opacity-100"
                )}
                priority
              />
            </div>
            <h1 className="text-3xl font-semibold sm:text-4xl text-[#0000a0] dark:text-white">
              Chat with Oppie
            </h1>
          </div>
          <ThemeToggle value={scheme} onChange={setScheme} />
        </header>

        <section className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-3xl bg-white/80 ring-1 backdrop-blur">
          <div className="flex min-h-0 flex-1">
            <ChatKitPanel
              theme={scheme}
              onThreadChange={handleThreadChange}
              onResponseCompleted={handleResponseCompleted}
            />
          </div>
        </section>
      </div>
      <ResearchStatus threadId={threadId} />
    </div>
  );
}
